var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.18,
    height: 17.581,
    viewBox: "0 0 9.18 17.581",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M95.631,277.074v2.832H95.41c-.547.005-1.09-.013-1.638.005-.746.023-1.3.311-1.324,1.246-.017.681-.029,2.247-.029,2.247s1.757.007,2.52,0h.6c-.143,1.084-.274,2.128-.411,3.184H92.441v7.938h-3.3V286.57H86.451v-3.159h2.712v-.24c0-.637-.011-1.275,0-1.913a8.439,8.439,0,0,1,.1-1.215,3.559,3.559,0,0,1,1.425-2.367,4.141,4.141,0,0,1,2.366-.727c.56-.011,1.12.012,1.676.036C95.034,277,95.344,277.044,95.631,277.074Z",
    transform: "translate(-86.451 -276.946)",
    fill: "#feb730"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0c9d854709351ba50c25b8727a9adc01.svg";
export { ForwardRef as ReactComponent };